import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

import Vue from "vue";
import axios from 'axios';
import App from "./App";
import router from "./router";
import GetTextPlugin from 'vue-gettext'
import translations from './translations/translations.json'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(GetTextPlugin, {
  availableLanguages: {
    en_us: 'American English',
    es_es: 'Español España',
    es_pr: 'Español Puerto Rico',
    es_do: 'Español República Dominicana',
  },
  defaultLanguage: 'es_es',
  translations: translations
});
Vue.prototype.$http = axios;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
